module.exports = __webpack_public_path__ + "static/media/ebook.c5fbfaef.svg";